import { render, staticRenderFns } from "./add-button.vue?vue&type=template&id=101763fb&scoped=true&"
import script from "./add-button.vue?vue&type=script&lang=ts&"
export * from "./add-button.vue?vue&type=script&lang=ts&"
import style0 from "./add-button.vue?vue&type=style&index=0&id=101763fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101763fb",
  null
  
)

export default component.exports